import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import '../../static/css/GrillaControls.css'

const GrillaEquipos = ({nombresEmpresas}) => {
    
    const { filteredData } = useSelector(state => state.dataDisp)
    const { listPage: pages } = useSelector(state => state.pages)
    const { perPage } = useSelector(state => state.perPage)

    const [ disp, setDisp ] = useState({});
    const [ inputEmp, setInputEmp] = useState('')
    const [ inputNombre, setInputNombre ] = useState('')
    const [ inputEmail, setInputEmail ] = useState('')
    const [ inputID, setInputID ] = useState('')
    const [ inputFono, setInputFono ] = useState('')

    const getData = (page, per_page) => {
        const start_index = page - 1;
        const start = start_index * per_page;
        const total_amount = (page * per_page);
        return filteredData.slice(start, total_amount)
    }
    
    const value = getData(pages, perPage);

    const showEditModal = (dispositivo) => {
        setDisp(dispositivo)
        setInputNombre(dispositivo.nombre)
        setInputEmp(dispositivo.empresa)
        setInputEmail(dispositivo.email)
        setInputID(dispositivo.id_equipo)
        setInputFono(dispositivo.fono)
        const editDialog = document.getElementById("editDialog");
        editDialog.showModal();
    }

    const showDeleteModal = (dispositivo) => {
        setDisp(dispositivo)
        const deleteDialog = document.getElementById("deleteDialog");
        deleteDialog.showModal();
    }

    return (
        <div style={{overflowX: "auto"}}>

            <dialog className='dialog' id="editDialog">  
                <form>
                    <div className='titleModal'>
                        <h4>Editar Equipo</h4>
                    </div>
                    <div className="contentModal">
                        <label className='inputModal'>ID Equipo:
                            <input className='inputSearchModal' value={inputID} type="text" onChange={(e) => setInputID(e.target.value)}></input>
                        </label>

                        <label className='inputModal'>Nombre:
                            <input className='inputSearchModal' value={inputNombre} type="text" onChange={(e) => setInputNombre(e.target.value)}></input>
                        </label>

                        <label className='inputModal'>Email:
                            <input className='inputSearchModal' value={inputEmail} type="text" onChange={(e) => setInputEmail(e.target.value)}></input>
                        </label>

                        <label className='inputModal'>Teléfono:
                            <input className='inputSearchModal' value={inputFono} type="tel" onChange={(e) => setInputFono(e.target.value)}></input>
                        </label>

                        <label className='inputModal'>Empresa:
                            <select className='inputSearchModal' value={inputEmp} onChange={(e) => setInputEmp(e.target.value)}>
                                {nombresEmpresas.map((nombre) => { 
                                    return <option key={nombre} value={nombre}>{nombre}</option>
                                })}
                            </select>
                        </label>
                    </div>
                    <div className='buttonsModal'>
                        <button className='buttonModal' value="cancel" formMethod="dialog">Cancelar</button>
                        <button className='buttonModal' style={{marginLeft: '0.5rem'}} id="confirmBtn" value="default">Confirmar</button>
                    </div>
                </form>
            </dialog>

            <dialog className='dialog' id="deleteDialog">  
                <form>
                    <div className='titleModal'>
                        <h4>Eliminar Equipo</h4>
                    </div>
                    <div className="contentModal">
                        <p>¿Realmente desea eliminar el Equipo móvil: <b>{disp.id_equipo}</b>?</p>
                    </div>
                    <div className='buttonsModal'>
                        <button className='buttonModal' value="cancel" formMethod="dialog">Cancelar</button>
                        <button className='buttonModal' style={{marginLeft: '0.5rem'}} id="confirmBtn" value="default">Eliminar</button>
                    </div>
                </form>
            </dialog>

            <table className="table">
                <thead>
                    <tr className='headers'>
                        <th className="headersTextmin" width="5%">#</th>
                        <th className="headersText" width="15%">ID Equipo</th>
                        <th className="headersText" width="15%">Nombre</th>
                        <th className="headersTextXL" width="25%">E-mail</th>
                        <th className="headersText" width="15%">Teléfono</th>
                        <th className="headersText" width="20%">Empresa</th>
                        <th className="headersText" width="15%"></th>
                    </tr>
                </thead>
                <tbody>
                { value.length === 0 
                ? (
                    <tr>
                        <td className="headersText">Sin registros</td>
                    </tr>
                )
                : value.map((element)=>{
                    return(
                        <tr key={element.id} className="fraction">
                            <td className="tdTextmin" width="5%" style={{textAlign: "left"}}>{element.id}</td>
                            <td className="tdText" width="15%" style={{textAlign: "left"}}>{element.id_equipo}</td>
                            <td className="tdText" width="15%" style={{textAlign: "left"}}>{element.nombre}</td>
                            <td className="tdTextXL" width="25%" style={{textAlign: "left"}}>{element.email}</td>
                            <td className="tdText" width="15%" style={{textAlign: "left"}}>{element.fono}</td>
                            <td className="tdText" width="20%" style={{textAlign: "left"}}>{element.empresa}</td>
                            <td className="tdText" width="15%">
                                <button className="buttonDetails" onClick={() => showEditModal(element)}>Editar</button>
                                <button className="buttonDetails" style={{marginLeft: "0.5rem", backgroundColor: "#FF9B85"}} onClick={() => showDeleteModal(element)}>Eliminar</button>
                            </td>
                        </tr>
                    )
                })}
                </tbody>
                <tfoot>
                    <tr className='spaceWithe' >
                        <td>
                            <br />
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    )
}

export default GrillaEquipos